import React from "react";

interface Props {
  id?: string;
  imgSrc: string;
  className?: string;
}

export default function KC_IconContainer(props: Props) {
  return (
    <div>
      <img src={props.imgSrc} className={`kc-icon ${props.className}`} />
    </div>
  );
}
